import React, {Component, lazy, Suspense} from 'react';
import {Layout} from './components/Layout';
import {Restaurants} from './screens/public/Restaurants/RestaurantsScreen';
import PublicMenuScreen from './screens/public/Menu/PublicMenuScreen';
import MenuItemScreen from './screens/public/Menu/MenuItemScreen';

import './custom.scss'
import './bootstrap-override.css'
import {Route, Routes} from 'react-router-dom';
import FoodScreen from './screens/admin/Food/FoodScreen';
import MenuScreen from './screens/admin/Menu/MenuScreen';
import LogoutScreen from './screens/auth/LogoutScreen';
import BusinessScreen from './screens/admin/Business/BusinessScreen';
import SignUpScreen from './screens/auth/SignUpScreen';
import PreparingScreen from './screens/proxy/PreparingScreen';


import MenuEditorScreen from "./screens/admin/Menu/Editor/MenuEditorScreen";
import {ActivityIndicator,} from "./custom-packages/react-native-components-in-react/react-native-components-in-react";
import MenuCustomizerScreen from "./screens/admin/Menu/Editor/MenuCustomizerScreen";
import DemoScreen from "./screens/public/LandingPage/DemoScreen";
import MarketingSettingsScreen from "./screens/admin/Settings/MarketingSettingsScreen";
import FreeTrialScreen from "./screens/promotion/FreeTrialScreen";
import BillingSettingsScreen from "./screens/admin/Settings/BillingSettingsScreen";
import MenuCategoryScreen from "./screens/admin/Menu/Editor/MenuCategoryScreen";
import PublicPollScreen from "./screens/public/Poll/PublicPollScreen";
import PollCreatorScreen from "./screens/admin/Poll/PollCreatorScreen";
import PollResultScreen from "./screens/admin/Poll/PollResultScreen";
import PollResponseScreen from "./screens/admin/Poll/PollResponseScreen";
import MenuPollScreen from "./screens/admin/Menu/Editor/MenuPollScreen";
import MenuHeaderScreen from "./screens/admin/Menu/Editor/MenuHeaderScreen";


const DownloadAppScreen = lazy(() => import("./screens/admin/Apps/DownloadAppScreen"));
const Home = lazy(() => import("./components/Home"));

const AuthScreen = lazy(() => import("./screens/auth/AuthScreen"));
const VerificationScreen = lazy(() => import("./screens/auth/VerificationScreen"));
const SettingsScreen = lazy(() => import("./screens/admin/Settings/SettingsScreen"));

//SETUP
const SetupBusinessScreen = lazy(() => import("./screens/auth/SetupBusinessScreen"));
const SetupRestaurantScreen = lazy(() => import("./screens/auth/SetupRestaurantScreen"));
const SetupSubscriptionPickerScreen = lazy(() => import("./screens/auth/SetupSubscriptionPickerScreen"));
const SetupSubscriptionResult = lazy(() => import("./screens/auth/SetupSubscriptionResult"));

//LEGAL
const TermsOfService = lazy(() => import("./screens/public/Legal/TermsOfService"));
const PrivacyPolicy = lazy(() => import("./screens/public/Legal/PrivacyPolicy"));

//SUPER-ADMIN
const TokenScreen = lazy(() => import("./screens/super-admin/Tokens/TokenScreen"));

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Suspense
                    fallback={
                        <div style={{paddingTop: 200}}>
                            <ActivityIndicator style={{marginTop: 15}}/>
                        </div>
                    }>
                    <Routes>
                        <Route exact path='/' element={<Home/>}/>
                        <Route exact path='/:lang' element={<Home/>}/>
                        <Route path='/demo' element={<DemoScreen/>}/>
                        <Route path='/marketing/:id' element={<MarketingSettingsScreen/>}/>
                        <Route path='/freetrial/:code' element={<FreeTrialScreen/>}/>
                        <Route path='/admin/setup' element={<SetupBusinessScreen/>}/>
                        <Route path='/admin/setup/restaurant' element={<SetupRestaurantScreen/>}/>
                        <Route path='/admin/setup/subscription' element={<SetupSubscriptionPickerScreen/>}/>
                        <Route path='/admin/setup/subscription/result' element={<SetupSubscriptionResult/>}/>
                        <Route path='/admin/survey/creator' element={<PollCreatorScreen/>}/>
                        <Route path='/admin/survey/results/:id' element={<PollResultScreen/>}/>
                        <Route path='/admin/survey/response/:id' element={<PollResponseScreen/>}/>

                        <Route path='/admin/menus' element={<MenuScreen/>}/>
                        <Route path='/admin/menus/editor/:id' element={<MenuEditorScreen/>}/>
                        <Route path='/admin/menus/customizer/:id' element={<MenuCustomizerScreen/>}/>

                        <Route path='/admin/menu/editor/:id' element={<MenuEditorScreen/>}/>
                        <Route path='/admin/menu/header/:id' element={<MenuHeaderScreen/>}/>
                        <Route path='/admin/menu/customizer/:id' element={<MenuCustomizerScreen/>}/>
                        <Route path='/admin/menu/survey/:id' element={<MenuPollScreen/>}/>
                        <Route path='/admin/menu/category/:id' element={<MenuCategoryScreen/>}/>

                        <Route path='/admin/food' element={<FoodScreen/>}/>
                        <Route path='/admin/business' element={<BusinessScreen/>}/>
                        <Route path='/admin/settings' element={<SettingsScreen/>}/>
                        <Route path='/admin/billing' element={<BillingSettingsScreen/>}/>
                        <Route path='/public/restaurants' element={<Restaurants/>}/>
                        <Route path='/public/menu/:id' element={<PublicMenuScreen/>}/>
                        <Route path='/public/menu/item/:id' element={<MenuItemScreen/>}/>
                        <Route path='/public/survey/:id' element={<PublicPollScreen/>}/>
                        <Route path='/auth' element={<AuthScreen/>}/>
                        <Route path='/register/:type' element={<SignUpScreen/>}/>
                        <Route path='/logout' element={<LogoutScreen/>}/>
                        <Route path='/verify/code' element={<VerificationScreen/>}/>
                        <Route path='/preparing' element={<PreparingScreen/>}/>
                        <Route path='/PrivacyPolicy' element={<PrivacyPolicy/>}/>
                        <Route path='/TermsOfService' element={<TermsOfService/>}/>
                        <Route path='/admin/apps' element={<DownloadAppScreen/>}/>
                        <Route path='/super-admin/tokens' element={<TokenScreen/>}/>
                    </Routes>
                </Suspense>
            </Layout>
        );
    }
}
